<template>
    <ModalError @cerrar="cerrarModalError" v-if="showModalError" :mensaje="mensajeError" />
  <Modal
  v-else
    cuerpoModal="overflow"
    @closeModal="handleCerrar"
    :showMovilHeader="true"
    :fit="true"
    :showHeader="false"
    :linea="false"
  >
    <Spinner class="position" :clase="false" v-if="loading" />
    <div class="closeModal-container">
      <img
        @click="handleCerrar"
        class="hide-movil"
        src="@/assets/imgs/icons/icono-cerrarModal.svg"
      />
    </div>
    <h3 class="title">Registrar cliente</h3>
    <div class="form-container">
      <div class="body-container">
        <input
          placeholder="Nombre"
          v-model="nombre"
          class="input"
          type="text"
        />
        <input
          placeholder="Apellido Paterno"
          v-model="apellido"
          class="input"
          type="text"
        />
        <input
          placeholder="Apellido Materno"
          v-model="segundoApellido"
          class="input"
          type="text"
        />
        <DropdownDate
          @fecha="getDate"
          id="dropdown"
          :maxWidth="true"
          class="select-item"
          format="DD-MM-YYYY"
          clase="border: 1px solid #afafaf; color:#616161"
        />
        <div>
          <input
            @blur="validateCel"
            placeholder="Celular"
            class="input"
            v-model="celular"
            type="text"
          />
          <p v-if="showErrorCel" class="mensajeError">Deben ser 10 dígitos</p>
        </div>
        <div>
          <input
            @blur="validateEmail"
            placeholder="Correo electrónico"
            v-model="correo"
            class="input"
            type="text"
          />
          <p v-if="showErrorEmail" class="mensajeError">
            El formato ingresado no es el correcto
          </p>
        </div>
      </div>
      <div class="btns-container">
        <button @click="handleRegresar" class="btn-regresar">Regresar</button>
        <button @click="registrar" :disabled="disabled" class="btn-registrar">
          Registrar
        </button>
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from "../Modales/Modal.vue";
import { validateNoErrors } from "../../helpers/helpers";
import appoinmentsService from "../../services/appoinmentService";
import Spinner from "../Loaders/spinner.vue";
import ModalError from '../Modales/ModalError.vue';
import DropdownDate from '../Dropdowns/DropdownDate.vue';
export default {
  components: {
    Modal,
    Spinner,
    ModalError,
    DropdownDate
  },
  emits: ["cerrar", "regresar","exito"],
  data() {
    return {
      nombre: "",
      apellido: "",
      segundoApellido: "",
      celular: "",
      correo: "",
      showErrorCel: false,
      showErrorEmail: false,
      showModalError:false,
      mensajeError:"",
      loading: false,
      fechaNacimiento:""
    };
  },
  methods: {
    handleCerrar() {
      this.$emit("cerrar");
    },
    getDate(fecha){
      this.fechaNacimiento = fecha
    },
    cerrarModalError(){
        this.showModalError = false
    },
    handleRegresar() {
      this.$emit("regresar");
    },
    async registrar() {
      try {
        this.loading = true;
        const data = {
          name: this.nombre,
          first_lastname: this.apellido,
          second_lastname: this.segundoApellido,
          telephones: this.celular,
          email: this.email,
          birthdate:this.fechaNacimiento
        };
        const res = await appoinmentsService.clienteNuevo(data);
        this.loading = false;
        this.$emit("exito",res)
      } catch (error) {
        console.log(error);
        this.loading = false;
        this.showModalError = true
        this.mensajeError = error.data?.message || "Ocurrio un error al agregar el cliente"
      }
    },
    validateEmail() {
      const correoValido = validateNoErrors("email", this.correo);
      correoValido
        ? (this.showErrorEmail = false)
        : (this.showErrorEmail = true);
    },
    validateCel() {
      const telefonoValido = validateNoErrors("telephones", this.celular);
      telefonoValido ? (this.showErrorCel = false) : (this.showErrorCel = true);
    },
    handleDisabled() {
      const telefonoValido = validateNoErrors("telephones", this.celular);
      const correoValido = validateNoErrors("email", this.correo);
      if (telefonoValido) this.showErrorCel = false;
      if (correoValido) this.showErrorEmail = false;
      if (this.correo) {
        if (
          this.nombre != "" &&
          this.apellido != "" &&
          telefonoValido &&
          correoValido
        )
          return false;
      } else {
        if (this.nombre != "" && this.apellido != "" && telefonoValido)
          return false;
      }
      return true;
    },
  },
  computed: {
    disabled() {
      return this.handleDisabled();
    },
  },
};
</script>

<style scoped>
.closeModal-container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 10px;
}

.btns-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 0 30px 0;
}
.btn-regresar {
  width: 172px;
  height: 22px;
  text-align: center;
  font: normal normal bold 16px/22px Open Sans;
  letter-spacing: 0px;
  color: #4caf50;
}
.btn-registrar {
  width: 172px;
  text-align: center;
  height: 40px;
  background: #4caf50 0% 0% no-repeat padding-box;
  border-radius: 4px;
  color: #fff;
}

.btn-registrar:disabled {
  opacity: 0.5;
  cursor: no-drop;
}

.title {
  font: normal normal bold 20px/27px Open Sans;
  letter-spacing: 0px;
  color: #0a4f9c;
  margin-bottom: 10px;
}

.input {
  width: 100%;
  height: 40px;
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #afafaf;
  border-radius: 4px;
  padding-left: 7px;
  font: normal normal normal 16px/22px Open Sans;
  letter-spacing: 0px;
  color: #616161;
}

.input::placeholder {
  opacity: 0.5;
}

.mensajeError {
  height: min-content;
  margin: 0;
  margin-top: 5px;
  color: #ff3737;
}

.position {
  position: absolute;
  top: 0;
  left: 0;
}

.body-container {
  height: 350px;
  width: 500px;
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: auto;
  row-gap: 15px;
  padding: 10px 0px;
}

.hide-movil {
  cursor: pointer;
}

@media screen and (max-width: 767px) {
  .hide-movil {
    display: none;
  }

  .body-container {
    width: 100%;
  }
  .form-container {
    height: 100vh;
  }

  .btns-container {
    margin-top: 140px;
  }

  .title {
    margin-top: 20px;
  }
}
</style>
